import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import get from 'lodash.get'

import Typography from 'components/atoms/Typography'
import LinkHandler from 'components/atoms/LinkHandler'
import { startsWithHttp } from 'helpers/strings'

// Styles
import './CardIllustration.scss'

function CardIllustration(props) {
  const image = get(props, 'header.url')
  const imageAlt = get(props, 'header.alt')
  const title = get(props, 'body.title')
  const description = get(props, 'body.text')
  const link = get(props, 'body.link.url')
  const linkText = get(props, 'body.link.text')
  const icon = get(props, 'body.link.icon')
  const iconRefLink = startsWithHttp(link) ? 'diagonal-arrow-right-up' : `${icon}`

  function cardIllustrationContent() {
    return (
      <>
        {image && (
          <div className="card-illustration-header">
            <img src={image} alt={imageAlt} />
          </div>
        )}
        <div className="card-illustration-body">
          <h3>{title}</h3>
          {ReactHtmlParser(description)}
        </div>
        <div className="d-flex justify-content-center align-items-center w-100">
          <Typography color="primary" cssClass="mt-auto">
            {linkText}
          </Typography>
          <i className={`ml-2 text-primary icone-${iconRefLink}`}></i>
        </div>
      </>
    )
  }

  return link ? (
    <LinkHandler className="card-illustration" to={link}>
      {cardIllustrationContent()}
    </LinkHandler>
  ) : (
    <div className="card-illustration">{cardIllustrationContent()}</div>
  )
}

export default CardIllustration
